<template>
	<v-col class="py-0 text--primary" cols="12" >
		<v-row >
			<v-col class="pb-1 body-2 font-weight-medium" cols="6" sm="3" order="1" order-sm="1">
				{{ comment.user }}
			</v-col>
			<v-col class="pb-1 body-2" cols="12" sm="6" order="3" order-sm="2">
				<template v-if="+comment.system">
					<v-chip
						small
						label
						color="primary"
					>
						<v-icon left v-if="systemIcon.name" small :color="systemIcon.color">{{ systemIcon.name }}</v-icon>
						{{ systemText }}
					</v-chip>
				</template>
			</v-col>
			<v-col class="pb-1 caption text-right" cols="6" sm="3" order="2" order-sm="3">
				{{ comment.time }}
			</v-col>
			<v-col class="py-1 body-2" v-if="commentText.length" cols="12" order="4" order-sm="4">
				<span v-html="commentText"></span>
			</v-col>
			<v-col
				class="py-1 body-2"
				v-for="file in comment.files"
				:key="file.url"
				cols="12"
				order="5"
				order-sm="5"
			>
				<v-chip
					small
					label
					link
					target="_blank"
					:href="file.url"
				>
					<v-icon small left>attach_file</v-icon>
					{{ file.name }}
				</v-chip>
			</v-col>
		</v-row>
	</v-col>
</template>

<script>

import { linkify } from '../../js/common'
import { systemComment as prSystemComment, systemIcon as prSystemIcon } from '../../js/pr.js'
import { systemComment as poSystemComment, systemIcon as poSystemIcon } from '../../js/po.js'
import { systemComment as mmSystemComment, systemIcon as mmSystemIcon } from '../../js/mm.js'

export default {
	props: {
		type: String,
		comment: Object
	},
	computed: {
		systemIcon() {
			if (!this.comment.system || !this.comment.systemText) return ''
			else if (this.type == 'bud') {
				if (this.comment.systemText == 'approved') {
					return {
						name: 'check_circle',
						color: 'green'
					}
				}
				else {
					return {
						name: '',
						color: ''
					}
				}
			}
			else if (this.type == 'pr') {
				return prSystemIcon(this.comment.systemText)
			}
			else if (this.type == 'po') {
				return poSystemIcon(this.comment.systemText)
			}
			else if (this.type == 'mm') {
				return mmSystemIcon(this.comment.systemText)
			}
			else {
				return {
					name: '',
					color: ''
				}
			}
		},
		systemText() {
			if (!this.comment.system || !this.comment.systemText) return ''
			else if (this.type == 'bud') {
				if (this.comment.systemText == 'approved') {
					return 'Согласовано'
				}
				else if (this.comment.systemText == 'withdraw') {
					return 'Решение отозвано'
				}
				else {
					let arr = this.comment.systemText.split('-')
					if (arr[0] == 'newVersion') {
						return 'Загружена версия ' + arr[1]
					}
					else return ''
				}
			}
			else if (this.type == 'pr') {
				return prSystemComment(this.comment.systemText)
			}
			else if (this.type == 'po') {
				return poSystemComment(this.comment.systemText)
			}
			else if (this.type == 'mm') {
				return mmSystemComment(this.comment.systemText)
			}
			else return ''
		},
		commentText() {
			let text = this.comment.text
			text = linkify(text)
			text = text.replace(/=>/g, '&rarr;')

			return text
		},
	}
}

</script>
